import React from 'react';
import styled from 'styled-components';

function Launch_vehicle() {
    return(
        <>
            <div id="vehicle-section">
                <div id="info-container">
                    <p id="vehicle-title">
                        LAUNCH&nbsp;VEHICLE
                    </p>
                    <p className="tech-info" id="information">
                        A launch vehicle or carrier rocket is a rocket-propelled vehicle used to carry a payload from 
                        Earth's surface to space, usually to Earth orbit or beyond. Our WEB-X carrier rocket is the most 
                        powerful in operation. Standing 150 metres tall, it's quite an awe-inspiring sight on the launch 
                        pad!
                    </p>
                </div>
            </div>
        </>
    );
}

export default Launch_vehicle;